
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/Logo";

export const IndexHeader = () => {
  return (
    <header className="bg-slate-100 border-b border-gray-200">
      <div className="container mx-auto px-3 py-3 md:px-4 md:py-4 lg:py-6">
        {/* Mobile Layout */}
        <div className="md:hidden">
          <div className="flex flex-col gap-3">
            {/* Buttons bar at top */}
            <div className="flex items-center justify-center gap-2">
              <Button 
                variant="ghost" 
                size="sm" 
                className="text-xs px-3 py-2 h-8 font-medium" 
                asChild
              >
                <Link to="/login">Entrar</Link>
              </Button>
              <Button 
                size="sm" 
                className="bg-brand-teal hover:bg-brand-teal/90 text-xs px-4 py-2 h-8 font-medium whitespace-nowrap" 
                asChild
              >
                <Link to="/signup">Começar</Link>
              </Button>
            </div>
            {/* Logo below buttons */}
            <div className="flex justify-center">
              <Logo size="md" showIcon={true} />
            </div>
          </div>
        </div>

        {/* Desktop Layout */}
        <nav className="hidden md:flex justify-between items-center">
          <Logo size="md" showIcon={true} />
          <div className="flex items-center gap-4">
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-sm px-4 py-2 h-9 font-medium" 
              asChild
            >
              <Link to="/login">Entrar</Link>
            </Button>
            <Button 
              size="sm" 
              className="bg-brand-teal hover:bg-brand-teal/90 text-sm px-4 py-2 h-9 font-medium whitespace-nowrap" 
              asChild
            >
              <Link to="/signup">Começar</Link>
            </Button>
          </div>
        </nav>
      </div>
    </header>
  );
};
